import React from "react"
import { useNavigate } from "react-router-dom"

type IProps = {
  textButton: string
  redirectTo?: string
  className?: string
}

const ReturnPageButton = ({ textButton, redirectTo, className }: IProps): React.JSX.Element => {
  const navigate = useNavigate()

  const onButtonClick = () => {
    if (redirectTo) {
      navigate(redirectTo)
    } else {
      navigate(-1)
    }
  }

  return (
    <button className={`btn btn-outline-secondary ${className}`} onClick={onButtonClick}>{textButton}</button>
  )
}

export default ReturnPageButton
